import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PortfolioPage from './pages/PortfolioPage';
import CVPage from './pages/CVPage';
import RunningPage from './pages/RunningPage';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<PortfolioPage/>} />
          <Route path='/portfolio' element={<Navigate to="/" replace />} />
          <Route path='/cv' element={<CVPage/>} />
          <Route path='/running' element={<RunningPage/>} />
          <Route path="*" element={<PortfolioPage/>} />
        </Routes>
      </Router>
      
    </div>
  );
}

export default App;
